import {
  EmbedItemType,
  MessageBoxItemType,
  PdfViewerRedirect,
} from '../../PdfViewer/index.types';
import { adaptOneToOneDocument } from '../index.types';
import V2ViewerShell from '../V2ViewerShell';

interface Props {
  data: PdfViewerRedirect;
  domain?: string;
  messageBoxItems?: MessageBoxItemType[];
  embedItems?: EmbedItemType[];
  translateKoToEn: (item: string) => string;
}

/** 1:1 공유 PDF의 V2 뷰어 진입점 */
const V2OneToOneViewer = ({
  data,
  domain,
  messageBoxItems,
  embedItems,
  translateKoToEn,
}: Props) => {
  return (
    <V2ViewerShell
      document={adaptOneToOneDocument(data)}
      isBulk={false}
      domain={domain}
      messageBoxItems={messageBoxItems}
      embedItems={embedItems}
      translateKoToEn={translateKoToEn}
    />
  );
};

export default V2OneToOneViewer;
